import { inTeams, teamsToken } from './teams.js';
/** workspace-api 클라이언트. 화면과 API는 같은 origin이라 상대경로로 호출한다. */
/** details — 서버가 고칠 거리로 돌려준 것(예: 반복 예약의 겹치는 회차 목록 details.conflicts) */
export class ApiError extends Error {
  constructor(status, message, code, details) { super(message); this.status = status; this.code = code; this.details = details; }
}

async function call(method, path, body) {
  const headers = body === undefined ? {} : { 'content-type': 'application/json' };
  // Teams 탭 안에서는 쿠키 대신 Teams 사용자 토큰을 붙인다
  if (inTeams()) headers.authorization = `Bearer ${await teamsToken()}`;
  const res = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers,
    body: body === undefined ? undefined : JSON.stringify(body)
  });
  if (res.status === 204) return null;
  const text = await res.text();
  let json = null;
  try { json = text ? JSON.parse(text) : null; } catch { /* 아래에서 처리 */ }
  if (!res.ok) {
    const msg = json?.error?.message ?? `요청이 실패했습니다 (${res.status})`;
    throw new ApiError(res.status, msg, json?.error?.code, json?.error?.details);
  }
  return json;
}

export const api = {
  get: (p) => call('GET', p),
  post: (p, b) => call('POST', p, b ?? {}),
  patch: (p, b) => call('PATCH', p, b ?? {}),
  put: (p, b) => call('PUT', p, b ?? {}),
  del: (p) => call('DELETE', p)
};

// 로그인으로 가기 전에 알림 링크(#/...)를 기억해 두고, 돌아오면 그 화면을 연다
export const login = () => {
  if (inTeams()) return;   // Teams 안에서는 Entra 로그인 화면을 띄울 수 없다(토큰 방식)
  try { if (window.location.hash) sessionStorage.setItem('ws-return', window.location.hash); } catch { /* 저장소 불가 시 무시 */ }
  window.location.href = '/auth/login';
};
export const logout = async () => {
  if (inTeams()) return;   // Teams 안에서는 Teams 계정 그대로 쓴다
  await api.post('/auth/logout'); window.location.href = '/auth/login';
};
